<snoots-page-generic
  [toolbarInput]="toolbar()"
  [noMargin]="true"
  [bgClasses]="background"
>
  <div class="flex flex-1 flex-col {{ background ? background : 'bg-white' }} ">
    @if (dxToolbarItems && dxToolbarItems.length > 0) {
      <div class="flex px-2 py-2">
        <dx-toolbar [items]="dxToolbarItems" class="bg-container"></dx-toolbar>
      </div>
    }

    <div class="flex flex-col flex-1">
      @if (search) {
        <div class="flex items-center justify-center p-4">
          <snt-text-box
            [debounceTime]="search.debounceTime"
            (value)="search.search.emit($event)"
            (startTyping)="search.startTyping.emit()"
            (endTyping)="search.endTyping.emit()"
            class="w-64"
          ></snt-text-box>
        </div>
      }

      <div class="relative flex-1">
        @if (!items || items.length === 0) {
          <div
            class="flex flex-col items-center justify-center w-full h-custom-height"
          >
            <div>
              <i class="fa-light fa-face-frown-open fa-8x"></i>
            </div>
            <div class="font-semibold text-slate-900">
              <p>{{ noDataText }}</p>
            </div>
          </div>
        }
        <div
          class="{{
            disableScroll ? '' : 'absolute'
          }} top-0 bottom-0 left-0 right-0 flex flex-col"
        >
          <div
            class="
          grid grid-cols-1
          gap-4
          {{ noPadding ? '' : 'p-4' }}
          {{
              !singleColumn
                ? 'sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4'
                : 'grid-cols-1'
            }}
        "
          >
            @for (item of items; track item) {
              <div
                #cardItem
                (click)="onClick.emit(item.data)"
                class="{{
                  item.disableHover && item.editDisabled ? '' : 'group'
                }} relative flex flex-col flex-1"
              >
                @if (dragEnabled) {
                  <dx-draggable
                    [clone]="true"
                    [group]="dragGroupName"
                    [data]="item.dragData"
                    [width]="cardItem.clientWidth"
                    (onDragStart)="onItemDragStart(cardItem, $event)"
                    (onDragEnd)="onItemDragEnd($event)"
                  >
                    <ng-template
                      [ngTemplateOutlet]="cardContent"
                      [ngTemplateOutletContext]="{
                        $implicit: item
                      }"
                    ></ng-template>
                  </dx-draggable>
                }
                @if (!dragEnabled) {
                  <ng-template
                    [ngTemplateOutlet]="cardContent"
                    [ngTemplateOutletContext]="{
                      $implicit: item
                    }"
                  ></ng-template>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #cardContent let-item>
    <div
      class="
              flex flex-col flex-1
              p-2
              border
              border-slate-200
              rounded-md
              cursor-pointer
              bg-white
              transition-all
              {{
        item.disableHover
          ? ''
          : 'group-hover:absolute group-hover:top-0 group-hover:left-0 group-hover:right-0 group-hover:z-10 group-hover:shadow-xl'
      }}
            "
    >
      @if (item.badgeText) {
        <div
          class="absolute top-0 right-0 px-2 py-1 rounded-bl-md rounded-tr-md bg-slate-200"
        >
          <span class="text-slate-700">{{ item.badgeText }}</span>
        </div>
      }

      @if (!item.hideHeader) {
        <div class="flex flex-row">
          @if (!item.avatarIcon) {
            <pms-avatar-nominative
              [text]="item.title || ''"
              [size]="32"
            ></pms-avatar-nominative>
          }
          @if (item.avatarIcon) {
            <div
              class="flex items-center justify-center w-8 h-8 rounded-full bg-slate-300"
            >
              <span>
                <i class="{{ item.avatarIcon }} text-slate-900"></i>
              </span>
            </div>
          }
          <div class="flex flex-1 ml-2 mr-2">
            <div class="relative flex-1">
              <div
                class="absolute top-0 bottom-0 left-0 right-0 flex items-center"
              >
                <div
                  class="flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap items-center"
                >
                  <div class="flex flex-row justify-between">
                    <span class="text-lg text-slate-900">
                      {{ item.title }}
                    </span>
                    @if (item.secondaryIcon) {
                      <span [sntTooltip]="item.secondaryIconTooltip">
                        <i class="{{ item.secondaryIcon }} text-lg"></i>
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (!item.editDisabled) {
            <div class="flex items-center ml-2">
              <snt-button-icon
                (onClick)="item.onClick.emit()"
                [icon]="item.actionIcon || 'fa-light fa-check'"
              ></snt-button-icon>
            </div>
          }
        </div>
      }

      <div class="flex flex-col flex-1">
        @for (line of item.lines; track line) {
          <div class="flex flex-row mb-2">
            <div
              class="flex flex-row items-center justify-center w-8 text-gray-700"
            >
              <i [class]="line.icon"></i>
            </div>
            <div class="relative flex-1 ml-2">
              &nbsp;
              <div
                class="absolute inset-0 overflow-hidden text-ellipsis whitespace-nowrap text-slate-900"
              >
                <span class="">
                  {{ line.text }}
                </span>
              </div>
            </div>
          </div>
        }
      </div>

      @if (titleChild) {
        <div class="p-2 font-semibold">
          {{ titleChild.title }}
        </div>
      }

      @if (description) {
        <div class="p-2">
          {{ description.description }}
        </div>
      }

      @if (item.content) {
        <div class="h-px my-2 bg-gray-200"></div>
        <div>
          <ng-container
            *ngTemplateOutlet="item.content.templateRef"
          ></ng-container>
        </div>
      }

      @if (item?.actions && item.actions.length > 0) {
        <div class="h-px my-2 bg-gray-200"></div>
        <div class="flex flex-row overflow-hidden group-hover:flex-wrap">
          @for (action of item.actions; track action) {
            <div
              (click)="action.onCLickFunction($event)"
              class="flex flex-row items-center p-2 px-4 mr-2 text-gray-600 border rounded-full"
              [ngClass]="
                action.disabled()
                  ? ''
                  : 'cursor-pointer group hover:text-slate-900 group-hover:mb-2'
              "
            >
              <i class="transition-transform {{ action.icon }}"></i>
              @if (action.title) {
                <span class="ml-2 whitespace-nowrap">{{ action.title }}</span>
              }
            </div>
          }
          @if (item.status === "online") {
            <div
              class="flex flex-row p-2 px-4 ml-auto mr-2 text-gray-100 bg-green-700 border rounded-full cursor-pointer group-hover:mb-2"
            >
              {{ item.statusLabel }}
            </div>
          }
          @if (item.status === "offline") {
            <div
              class="flex flex-row p-2 px-4 ml-auto mr-2 text-gray-100 bg-red-700 border rounded-full cursor-pointer group-hover:mb-2"
            >
              {{ item.statusLabel }}
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</snoots-page-generic>
